import styled from 'styled-components'

const TicketsStyle = styled.div.attrs()`
	--paddLeftRightWrap: var(--sp25x);
	--leftWidth: calc(57% - var(--paddLeftRightWrap));
	--rightWidth: calc(100% - var(--leftWidth) - var(--paddLeftRightWrap));
	--tabTitlePadd: var(--sp2x);
	--infoItemPaddBottom: var(--sp3x);
	--infoItemTopMarg: var(--sp13x);
	--rightWrappPaddTop: var(--sp20x);
	--rightWrappPaddleft: var(--sp15x);
	--informationTitleMargBott: var(--sp3x);
	--starIconSize: var(--sp4-5x);
	--imageContWidth: var(--sp5-5x);
	--imageContHeight: var(--sp3-5x);
	--imageContMarg: var(--sp2x);

	.freePolicyContent {
		p {
			font-size: var(--pM);
			font-family: NotoSansRegular;
			margin-bottom: var(--sp4x);

			strong {
				font-family: NotoSansBold;
			}
		}

		ul {
			list-style: unset;
			list-style-position: inside;
		}
	}

	.ticketsWrapp {
		.pL,
		.infoItemTitle {
			line-height: var(--lineHeightXS);
		}
		.leftWrapp {
			width: var(--leftWidth);
			min-height: 70vh;
			.tabWrapp {
				margin-bottom: var(--infoItemTopMarg);
				.tabTitle {
					width: 50%;
					background-color: var(--backColor);
					color: var(--textColor);
					padding: var(--tabTitlePadd);
					border: 1px solid var(--textColor);
					border-top-right-radius: var(--sp8x);
					border-top-left-radius: var(--sp8x);
					&.active {
						background-color: var(--textColor);
						color: var(--backColor);
					}
				}
			}
			.tabItem {
				transition: all var(--trTime) ease;
				opacity: 0;
				visibility: hidden;
				position: absolute;
				top: 0;
				bottom: 0;
				left: 0;
				right: 0;

				&.active {
					transition: all var(--trTime3) ease;
					opacity: 1;
					visibility: visible;
					position: static;
				}
				.infoItemWrapp {
					margin-top: var(--infoItemTopMarg);
					&:first-child {
						margin-top: 0;
					}
					.infoItem {
						margin-bottom: var(--infoItemPaddBottom);
						> .FlexBoxContainer {
							padding-bottom: var(--infoItemPaddBottom);
							&:last-child {
								padding-bottom: 0;
							}
						}
						.itemLine {
							border-bottom: 1px solid var(--textColor);
						}
						&:last-child {
							margin-bottom: 0;
						}

						> .FlexBoxContainer {
							> .comp-title {
								max-width: 90%;
							}
						}

						.imageCont {
							width: var(--imageContWidth);
							height: var(--imageContHeight);
							&:not(:last-child) {
								margin-right: var(--imageContMarg);
							}
						}

						.otherInfoItem {
							padding-left: var(--pL);
							margin-top: calc(var(--titleMarg) - var(--infoItemPaddBottom));
							margin-bottom: calc(var(--titleMarg) - var(--infoItemPaddBottom));
							&:last-child {
								margin-bottom: 0;
							}
							> div {
								margin-bottom: var(--infoItemPaddBottom);
								&:last-child {
									margin-bottom: 0;
								}
								> .FlexBoxContainer {
									max-width: 70%;
									> .comp-title {
										max-width: calc(100% - (var(--pM) + var(--starIconSize)));
									}
								}
							}
							i {
								line-height: 1;
								margin-right: var(--pM);
								font-size: var(--starIconSize);
							}
						}
					}
				}
			}
		}
		.rightWrapp {
			width: var(--rightWidth);
			.right {
				background-color: var(--textColor);
				padding: var(--rightWrappPaddTop) var(--rightWrappPaddleft) calc(var(--rightWrappPaddTop) * 2);
				border-radius: var(--sp62x);
				color: var(--backColor);
				clip-path: ellipse(0% 0% at 50% 50%);
				transition: all var(--trTime2) ease;
				i {
					display: inline-block;
					margin-bottom: var(--rightWrappPaddTop);
					animation: starIconAnim 10s linear 0s infinite;
				}
				> div {
					width: 100%;
				}
				.allInformation {
					.comp-title.pL {
						line-height: var(--lineHeight);
					}
					.allInformationTitle {
						margin-bottom: var(--informationTitleMargBott);
					}
					a {
						display: inline-block;
						color: var(--backColor);
						line-height: var(--lineHeight);
						margin-bottom: var(--spSize);
						&:last-child {
							margin-bottom: 0;
						}
						&:hover {
							text-decoration: underline;
						}
					}
				}
				&.active {
					clip-path: ellipse(85% 50% at 50% 50%);
				}
			}
		}
	}

	@keyframes starIconAnim {
		0% {
			transform: rotate(0deg);
		}
		100% {
			transform: rotate(360deg);
		}
	}

	@media screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.DesktopSizeM}) {
		--paddLeftRightWrap: var(--sp19x);
		--infoItemTopMarg: var(--sp10x);
		--rightWrappPaddTop: var(--sp16x);
		--rightWrappPaddleft: var(--sp13x);
		--starIconSize: var(--sp3x);

		--imageContWidth: var(--sp4x);
		--imageContHeight: var(--sp2-8x);
		--imageContMarg: var(--sp1-5x);
	}

	@media screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeMMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.DesktopSizeS}) {
		--paddLeftRightWrap: var(--sp11x);
		--infoItemTopMarg: var(--sp9x);
		--rightWrappPaddTop: var(--sp12x);
		--rightWrappPaddleft: var(--sp10x);
	}

	@media screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.DesktopSizeXS}) {
		--paddLeftRightWrap: var(--sp9x);
		--infoItemTopMarg: var(--sp8x);
		--rightWrappPaddTop: var(--sp11x);
		--rightWrappPaddleft: var(--sp8x);
	}

	@media screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXSMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.LaptopSize}) {
		--paddLeftRightWrap: var(--sp6x);
		--infoItemTopMarg: var(--sp7x);
		--rightWrappPaddTop: var(--sp10x);
		--rightWrappPaddleft: var(--sp5x);
		--leftWidth: calc(54% - var(--paddLeftRightWrap));
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeMMin}) {
		--starIconSize: var(--sp2-5x);

		--imageContWidth: var(--sp3x);
		--imageContHeight: var(--sp2x);
		--imageContMarg: var(--spSize);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXSMin}) {
		--infoItemPaddBottom: var(--sp2x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.LaptopSizeMin}) {
		--leftWidth: 100%;
		--rightWidth: 100%;
		--infoItemTopMarg: var(--sp7x);
		--rightWrappPaddTop: var(--sp10x);
		--rightWrappPaddleft: var(--sp14x);
		--informationTitleMargBott: var(--sp2x);

		.rightWrapp {
			margin-top: var(--sp7x);
			i {
				font-size: var(--h3);
			}
		}
	}

	@media screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) {
		--infoItemTopMarg: var(--sp6x);
		--rightWrappPaddTop: var(--sp8x);
		--rightWrappPaddleft: var(--sp4x);
		.ticketsWrapp {
			.leftWrapp {
				.tabWrapp {
					.tabTitle {
						border-top-right-radius: var(--sp5-5x);
						border-top-left-radius: var(--sp5-5x);
					}
				}

				.tabItem {
					.infoItemWrapp {
						.infoItem {
							.itemAvailableLanguages {
								width: 100%;
								padding-top: var(--infoItemPaddBottom);
							}
						}
					}
				}
			}
		}
	}
`
export default TicketsStyle
